import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  /**
   * Current MarketCode code
   * @type {'CLC' | 'GLN' | null}
   */
  MarketCode: null,
};

const domainSlice = createSlice({
  name: 'domain',
  initialState,
  reducers: {
    setDomainMarketCode: (state, action) => {
      state.MarketCode = action.payload;
    },
  },
});

export const {setDomainMarketCode} = domainSlice.actions;
export default domainSlice.reducer;
